var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWelcomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 52,
    viewBox: "0 0 51 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 26.01,
    r: 25,
    fill: "#F4B652",
    stroke: "#F4B652"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4493 19.9813L24.9133 13.0053C25.0141 12.8034 25.1692 12.6336 25.3612 12.515C25.5531 12.3963 25.7743 12.3334 26 12.3334C26.2256 12.3334 26.4468 12.3963 26.6388 12.515C26.8307 12.6336 26.9858 12.8034 27.0866 13.0053L30.5506 19.9813L38.2946 21.1067C38.518 21.1376 38.7282 21.2308 38.9011 21.3755C39.0741 21.5202 39.2029 21.7106 39.2728 21.925C39.3428 22.1393 39.351 22.3691 39.2966 22.5879C39.2423 22.8068 39.1274 23.0059 38.9653 23.1627L33.3626 28.5893L34.6853 36.256C34.8546 37.24 33.8146 37.9893 32.9253 37.5253L26 33.904L19.0733 37.5253C18.1853 37.9907 17.1453 37.24 17.3146 36.2547L18.6373 28.588L13.0346 23.1613C12.8733 23.0045 12.7592 22.8055 12.7053 22.5871C12.6513 22.3686 12.6598 22.1394 12.7297 21.9255C12.7995 21.7116 12.928 21.5216 13.1005 21.3771C13.2729 21.2326 13.4825 21.1393 13.7053 21.108L21.4493 19.9813Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeIcon);
export default __webpack_public_path__ + "static/media/welcome_icon.92bfe09cd2404507c9e06c89865b1d75.svg";
export { ForwardRef as ReactComponent };